/**
 * action type constants related to fetching the user certificate requests log
 */
export const CERT_GEN_REQUESTS_FETCH_REQUEST =
  "CERT_GEN_REQUESTS_FETCH_REQUEST";
export const CERT_GEN_REQUESTS_FETCH_SUCCESS =
  "CERT_GEN_REQUESTS_FETCH_SUCCESS";
export const CERT_GEN_REQUESTS_FETCH_ERROR = "CERT_GEN_REQUESTS_FETCH_ERROR";
/**
 * action type constants related to requesting a certificate for an instance
 */
export const REQUEST_CERT_GEN = "REQUEST_CERT_GEN";
export const REQUEST_CERT_GEN_SUCCESS = "REQUEST_CERT_GEN_SUCCESS";
export const REQUEST_CERT_GEN_ERROR = "REQUEST_CERT_GEN_ERROR";
export const CLOSE_REQUEST_CERT_GEN_ERROR_POPUP =
  "CLOSE_REQUEST_CERT_GEN_ERROR_POPUP";
/**
 * action type constants related to downloading a created certificate
 */
export const DOWNLOAD_CERT_REQUEST = "DOWNLOAD_CERT_REQUEST";
export const DOWNLOAD_CERT_SUCCESS = "DOWNLOAD_CERT_SUCCESS";
export const DOWNLOAD_CERT_ERROR = "DOWNLOAD_CERT_ERROR";
export const CLOSE_DOWNLOAD_CERT_ERROR_POPUP =
  "CLOSE_DOWNLOAD_CERT_ERROR_POPUP";
/**
 * action type constants related to updating a particular user certificate request log entry
 */
export const UPDATE_CERT_GEN_LOG_ENTRY_STATUS =
  "UPDATE_CERT_GEN_LOG_ENTRY_STATUS";

export const CERT_GEN_REQ_STATUS_SUCCESS = "SUCCESS";
export const CERT_GEN_REQ_STATUS_REQUESTED = "REQUESTED";
export const CERT_GEN_REQ_STATUS_FAILED = "FAILED";

export const FETCH_LOG_STATUS_SUCCESS = "SUCCESS";
export const FETCH_LOG_STATUS_FETCHING = "FETCHING";
export const FETCH_LOG_STATUS_FAILED = "FAILED";

export const DOWNLOAD_CERT_STATUS_SUCCESS = "SUCCESS";
export const DOWNLOAD_CERT_STATUS_DOWNLOADING = "DOWNLOADING";
export const DOWNLOAD_CERT_STATUS_FAILED = "FAILED";

export const GENERIC_ERROR_MESSAGE =
  "Failed - Due to Technical error, Please try again";

export const CERT_NOT_FOUND_ERROR_MESSAGE =
  "Certificate does not exist. Request Intelliserve Admin to generate a certificate.";

export const CertStatus = {
  CREATED: {
    key: "CREATED",
    value: "Created",
  },
  IN_PROGRESS: {
    key: "IN_PROGRESS",
    value: "In progress",
  },
  FAILED: {
    key: "FAILED",
    value: "Failed - Due to Technical error, Please try again",
  },
};

export const EXISTS_VALIDATION_ERROR = "exists";
export const PATTERN_VALIDATION_ERROR = "pattern";

export const DIGI_CERT_ISSUER = "DigiCertCA";

export const DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm:ss';
